import { Star, CheckCircle } from "lucide-react";
import StarFill from "../common/StarFill";

interface EnterpriseProfileStatsProps {
  reviews: object;
  projectCount: number;
}

export const EnterpriseProfileStats = ({
  reviews,
  projectCount,
}: EnterpriseProfileStatsProps) => {

  const calculateAverageRating = (reviews) => {
    if (reviews?.length === 0) return 0;
    const sum = reviews?.reduce((total, review) => total + review.rating, 0);
    return sum / reviews?.length;
  };
  const averageRating = calculateAverageRating(reviews);

  return (
    <div className="grid grid-cols-2 gap-4 mb-6 text-center">
      <div>
        <div className="flex justify-center">
          <StarFill rating={averageRating} />  
          <span className="text-gray-600 ml-1">{averageRating || 0}/5</span>  
        </div>
        <p className="text-sm text-gray-500">Rating</p>
      </div>
      <div>
        <div className="flex items-center justify-center">
          <CheckCircle className="w-4 h-4 text-green-500 mr-1" />
          <span className="text-gray-600">{projectCount}</span>
        </div>
        <p className="text-sm text-gray-500">Projects Completed</p>
      </div>
    </div>
  );
};
